import { action, makeObservable, observable, reaction } from 'mobx';
import { popupStore } from '../../../store/popupStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { KeyA, KeyQ, KeyS, KeyW, Space } from '../../../core/constants/hotKeys';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { freeBetStore } from '../../../store/freeBetStore';
import { powerOfGodsBetsStore } from './betStore';
import { gameController } from '../powerOfGodControllers/gameController';
import { powerOfGodsGameService } from '../powerOfGodsService/gameService';
import { actions } from '../powerOfGodsCore/constants/globalConstants';
import { powerOfGodsStore } from './powerOfGodsStore';

class PowerOfGodsHotKeysStore {
  isStartHotKeys = false;

  isAllowUseHotKeys = true;

  hotKeysActions = {
    [Space]: () => {},
    [KeyA]: () => {
      const { isAllowToChangeBetAmount } = powerOfGodsBetsStore;
      return isAllowToChangeBetAmount && userInfoStore.decrementBet();
    },
    [KeyS]: () => {
      const { isAllowToChangeBetAmount } = powerOfGodsBetsStore;
      return isAllowToChangeBetAmount && userInfoStore.incrementBet();
    },
    [KeyW]: () => {
      const { isAllowCashOut } = powerOfGodsStore;
      if (gameController.checkPopUpAndClose() || !isAllowCashOut) return;
      powerOfGodsGameService.sendCashOut({ action: actions.cashOut });
    },
    [KeyQ]: () => {
      const { isAllowPartCashOut } = powerOfGodsStore;
      if (gameController.checkPopUpAndClose() || !isAllowPartCashOut) return;
      powerOfGodsGameService.sendPartCashOut({ action: actions.partCashOut });
    },
  };

  constructor() {
    makeObservable(this, {
      isStartHotKeys: observable,
      isAllowUseHotKeys: observable,
      handleKeyDown: action.bound,
      setIsStartHotKeys: action.bound,
    });
    reaction(
      () => userInfoStore.betAmount,
      (value) => {
        this.isAllowUseHotKeys =
          value >= userInfoStore.limits.minBet && value <= userInfoStore.limits.maxBet;
      }
    );
  }

  handleKeyDown(e) {
    if (e.code === Space) {
      e.preventDefault();
    }
    if (!popupStore.isOpenPopup && !powerOfGodsBetsStore.isBetsClosed && this.isAllowUseHotKeys) {
      const { currentFreeBet } = freeBetStore;
      if (e.code === Space || (this.hotKeysActions[e.code] && !currentFreeBet)) {
        this.hotKeysActions[e.code]();
      }
    }
  }

  setIsStartHotKeys(checked) {
    this.isStartHotKeys = checked;
    userSettingsStore.setIsHotKeyEnable(checked);
    if (checked) {
      window.addEventListener('keydown', this.handleKeyDown);
    } else {
      window.removeEventListener('keydown', this.handleKeyDown);
    }
  }
}

export const powerOfGodsHotKeysStore = new PowerOfGodsHotKeysStore();
